package songwritersnotebook.app.data

import kotlinx.serialization.Serializable
import com.benasher44.uuid.uuid4

// Represents ONE vertical moment in time (a vertical slice of the fretboard)
@Serializable
data class TabColumn(
    val id: String = uuid4().toString(),
    // The notes for strings 1-6 (High E down to Low E)
    val notes: List<String> = List(6) { "-" },
    // Instructional text for this slice of time (e.g. "P.M.", "vib")
    val instruction: String = ""
)

// The container for the whole tab block
@Serializable
data class GuitarTab(
    val id: String = uuid4().toString(),
    val name: String = "New Tab",
    val beats: Int = 4,
    val subdivisions: Int = 4, // Slots per beat (e.g., 4 = 16th notes)
    val columns: List<TabColumn> = emptyList(), // The sequence of vertical slices
    val beatSubdivisions: Map<String, Int> = emptyMap(), // Beat Index (as String) -> Subdivisions for that beat
    val recordingIds: List<String> = emptyList()
)
